import { Permissions } from '../../../../models/enums/permissions';
import * as React from 'react';
import ResultDialog from '../../../../components/dialog-types/ResultDialog';
import { PageActions } from '../../../../components/form-elements/FormSave';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { PageHeading } from '../../../../components/page-components/PageHeading';
import { useServiceCenter } from '../../../../hooks/use-service-center';
import { ShipToAddressRead } from '../../../../shared/models/ship-to-address-read';
import { AddressDisplay } from '../../../../support/components/dealers/AddressDisplay';
import { StatusCode } from '../../../../utils/api';
import { PageNames } from '../../../../utils/app-constants';
import { AppUtils } from '../../../../utils/app-utils';
import { history } from '../../../../utils/history';
import { DeliveryGroupControl } from '../components/DeliveryGroupControl';
import { TransportationSvc } from '../../../../transportation/service';
import '../../../../transportation/styles.scss';

interface IProps {
    location?    : any;
    match?       : any;
}

export const RoutingOrderListScene = (props : IProps) => {

    const [orderList, setOrderList]                 = React.useState([] as any[]);
    const [addressVM, setAddressVM]                 = React.useState<ShipToAddressRead>({} as unknown as ShipToAddressRead);
    const [showAllByDefault, setShowAllByDefault]   = React.useState(false);
    const userServiceCenter                         = useServiceCenter();
    const [shipmentType, setShipmentType]           = React.useState();
    const [filterDate, setFilterDate]               = React.useState<string|undefined>();
    const [addressId, setAddressId]                 = React.useState(0);
    const [dealerId, setDealerId]                   = React.useState('');
    const [division, setDivision]                   = React.useState<string>('');

    const CONTAINER_STRING  = 'containers';
    const TRUCK_STRING      = 'trucks';

    /**
     * Fetch the order list and address info
     */
    async function getData(aID : number, dID : string, cutoff : string|undefined, division:string|undefined) {

        if (aID && dID) {
            const svc = new TransportationSvc();
            const sc = userServiceCenter.name === 'ALL' ? 'MAIN' : userServiceCenter.name;
            const vm = await svc.getPlannedOrders(cutoff, aID, dID, division, sc);

            setOrderList(vm.data.orders);
            setAddressVM(vm.data.address);
        }
    }

    /**
     * Fetch the address
     */
    React.useEffect(() => {

        const urlParts = props.location.pathname.split('/');

        const urlParams = new URLSearchParams(window.location.search);
        const div = urlParams.get('division') || '';
        
        let section     = urlParts[3];
        const dID       = urlParts[4];
        const aID       = urlParts[5];
        const cutoff    = urlParts[6];
        
        section = (section as string).toLowerCase();
        setShipmentType(section);

        const shouldShowExtras = section === CONTAINER_STRING ? true : false;
        setShowAllByDefault(shouldShowExtras);

        if (cutoff && cutoff.length > 0) {
            setFilterDate(cutoff);
        }
        
        setAddressId(aID);
        setDealerId(dID);
        setDivision(div);
        getData(aID, dID, cutoff, div);

    }, [props.location.pathname]);
 
    /**
     * Post back the order list with the groups defined
     */
    const onSave = async () => {
        
        const tSvc = new TransportationSvc();
        const response = await tSvc.updateOrderGrouping(orderList);

        if (response.status === StatusCode.Success) {
            history.goBack();
        }

    };

    /**
     * Reset the state to be whatever was initially passesd 
     * in via the props
     */
    const onCancel = async () => {
        const result = await ResultDialog.show({
            title: 'Reset Changes?',
            message: 'Are you sure you want to reset the order groups?'
        });

        if (result) {
            getData(addressId, dealerId, filterDate, division);
            window.scroll({top: 0, left: 0, behavior: 'smooth' });
        }        
    };

    const goBack = () => {
        history.goBack();
    };

    return (<PageContent pageName={PageNames.TRANSPORTATION_PLANNING_ORDER_LIST}>
                <PageHeading 
                    shouldStick={ true } 
                    showBackBtn={ true }
                    onBackClick={ goBack }
                    title={ shipmentType === CONTAINER_STRING ? "Plan Container" : "Plan Delivery" }>
                    <PageActions
                            id="pickup-edit-form"
                            onEdit={ onSave }
                            editLabel="Save"
                            editPermissions={[
                                Permissions.RoutingRoutingImport
                            ]} 
                            onDelete={ onCancel }
                            deleteLabel="Reset"
                            deletePermissions={[
                                Permissions.RoutingRoutingImport
                            ]} 
                    />                    
                </PageHeading>
                <PageBody classes="planning-order-list">                        
                    {
                        !AppUtils.IsEmpty(addressVM) && addressVM.address
                            ? <AddressDisplay
                                label="Delivery Address"
                                name={ addressVM.name }
                                addressLine1={ addressVM.address.addressLine1 }
                                addressLine2={ addressVM.address.addressLine2 }
                                city={ addressVM.address.city }
                                state={ addressVM.address.stateProvince }
                                postalCode={ addressVM.address.postalCode }
                                phoneNumber={ addressVM.phoneNumber }
                                latitude={ addressVM.address.latitude }
                                longitude={ addressVM.address.longitude }
                            />
                            : <AddressDisplay
                                label="Delivery Address"
                                name={ addressVM.name }
                                addressLine1=""
                                addressLine2=""
                                city=""
                                state=""
                                postalCode=""
                                phoneNumber={ addressVM.phoneNumber }
                                latitude={ undefined }
                                longitude={ undefined }
                            />
                    }

                    <DeliveryGroupControl
                        showAllByDefault={ showAllByDefault }
                        orders={ orderList } />
            </PageBody>
        </PageContent>);
};
